module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Term")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTerm),
      expression: "selectedTerm"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTerm = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getVideos]
    }
  }, _vm._l((_vm.terms), function(term) {
    return _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v("\n                \t\t" + _vm._s(term.name) + "\n                \t")])
  }))]), _vm._v(" "), (_vm.groups) ? _c('div', {
    staticClass: "groups"
  }, _vm._l((_vm.groups), function(videos, id) {
    return _c('div', [_c('h4', {
      staticClass: "cursor-pointer",
      on: {
        "click": function($event) {
          _vm.selectedGroup === id ? _vm.selectedGroup = null : _vm.selectedGroup = id
        }
      }
    }, [_vm._v("\n                   \t\t" + _vm._s(_vm.determineGroupLabel(videos[0])) + "\n                   \t\t"), (_vm.selectedGroup === id) ? _c('i', {
      staticClass: "fa fa-caret-down"
    }) : _c('i', {
      staticClass: "fa fa-caret-right"
    })]), _vm._v(" "), (_vm.selectedGroup === id) ? _c('div', [_c('table', {
      staticClass: "table table-striped table-bordered "
    }, [_vm._m(0, true), _vm._v(" "), _c('tbody', _vm._l((videos), function(video) {
      return _c('tr', [_c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(video.week) + "\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s((video.duration / 60).toFixed(1)) + " min\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("shortDate")(video.createdAt)) + "\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_c('a', {
        attrs: {
          "href": video.url,
          "target": "_blank"
        }
      }, [_c('video', {
        attrs: {
          "width": "100"
        }
      }, [_c('source', {
        attrs: {
          "src": video.url,
          "type": "video/mp4"
        }
      })])])])])
    }))])]) : _vm._e()])
  })) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Week")]), _vm._v(" "), _c('th', [_vm._v("Duration")]), _vm._v(" "), _c('th', [_vm._v("Created")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Link")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6746811e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/DirectorIntroVideos.vue
// module id = 2034
// module chunks = 2